import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { ProductIrregularityReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
    providedIn: 'root'
})
export class ProductIrregularityReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/productirregularityreferences"

    constructor(httpClient: HttpClient,
        authService: AuthService,) {
        super(httpClient, authService);
    }

    public getByProductType(productTypeCode: string): Observable<ProductIrregularityReferenceModel[]> {
        return this.httpGet<ProductIrregularityReferenceModel[]>(this.PATH + "/producttypes/" + productTypeCode, null)
            .pipe(
                map(res => res.body)
            )
    }
}